import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gtd-ui-field-default-string-or-default',
  templateUrl: './string-or-default.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StringOrDefaultComponent {
  @Input() data: any;
  @Input() customClass = '';
  public defaultValue = $localize`:@@common.default:Default`;
}
